import { useEffect, useState } from 'react';
import { Row, Col, Card, Statistic, theme } from 'antd';
import { countsTickets } from 'api/tickets';

const ESTADOS = [
  { key: 'nuevo', label: 'Nuevos' },
  { key: 'en_proceso', label: 'En proceso' },
  { key: 'resuelto', label: 'Resueltos' },
  { key: 'cerrado', label: 'Cerrados' },
];

export default function TicketsKpiStrip({ filters, reloadKey, activeEstado, onToggleEstado }) {
  const { token } = theme.useToken();
  const [counts, setCounts] = useState({});

  const { estado, ...countFilters } = filters || {};

  useEffect(() => {
    countsTickets(countFilters)
      .then(setCounts)
      .catch(() => setCounts({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps son primitivas individuales abajo
  }, [
    reloadKey,
    countFilters.prioridad,
    countFilters.clienteId,
    countFilters.search,
    countFilters.dateFrom,
    countFilters.dateTo,
  ]);

  return (
    <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
      {ESTADOS.map(({ key, label }) => (
        <Col xs={12} md={6} key={key}>
          <Card
            size="small"
            hoverable
            onClick={() => onToggleEstado(activeEstado === key ? undefined : key)}
            style={{
              borderColor: activeEstado === key ? token.colorPrimary : token.colorBorderSecondary,
            }}
          >
            <Statistic title={label} value={counts[key] ?? 0} />
          </Card>
        </Col>
      ))}
    </Row>
  );
}
